/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
/**
WIDGETS :
Measures
Orders and Progress Notes
*/

export const WidgetWrapper = styled.div.withConfig({
  displayName: "widgetWrapper__WidgetWrapper",
  componentId: "sc-1qla43x-0"
})(["", " ", " display:flex;flex-direction:column;align-items:center;position:relative;overflow:scroll;overscroll-behavior:contain;padding-left:10px;padding-right:5px;"], props => {
  const {
    getFullSizeHeight,
    smallWidgetHeight
  } = props.theme.props.dashboard;
  const {
    smallWidget
  } = props;
  const maxHeight = getFullSizeHeight(window.innerHeight);
  return smallWidget ? `height: ${smallWidgetHeight}px;
         min-height: ${smallWidgetHeight}px;` : `height: ${maxHeight}px;
         max-height: ${maxHeight}px;`;
}, props => {
  const {
    paper
  } = props.theme.palette.background;
  return `border: 2px solid ${paper};
            background-color: ${paper};`;
}); //  overscroll-behavior: contain;

/**
AG GRID WIDGETS:
HIS
Care Plan Problems
Visit Frequency
Scheduled Visit
Patient Listing
*/

export const AgGridWidgetWrapper = styled.div.withConfig({
  displayName: "widgetWrapper__AgGridWidgetWrapper",
  componentId: "sc-1qla43x-1"
})(["", " background-color:", ";width:100%;position:relative;overscroll-behavior:contain;"], props => {
  const {
    smallWidgetHeight,
    getFullSizeHeight
  } = props.theme.props.dashboard;
  const {
    smallWidget
  } = props;
  const maxHeight = getFullSizeHeight(window.innerHeight);
  const height = props.heightOffset ? maxHeight - props.heightOffset : maxHeight;
  return smallWidget ? `min-height: ${smallWidgetHeight}px;
         height: ${smallWidgetHeight}px;` : `height: ${height}px;
         max-height: ${maxHeight}px;`;
}, props => props.theme.palette.background.paper); // todo offset
// offset for Patient Listing as needs 20px // 20px is the size of header of the table

export const AgGridTableWrapper = styled.div.withConfig({
  displayName: "widgetWrapper__AgGridTableWrapper",
  componentId: "sc-1qla43x-2"
})(["", " background-color:", ";overflow:", ";"], props => props.printMode ? `width: 750px;` : `height: inherit;`, props => props.theme.palette.background.paper, props => props.scroll && 'scroll' || 'auto');
export const AgGridTableWrapperOffset = styled.div.withConfig({
  displayName: "widgetWrapper__AgGridTableWrapperOffset",
  componentId: "sc-1qla43x-3"
})(["", " background-color:", ";overflow:auto;"], props => props.printMode ? `width: 750px;` : props.smallWidget ? `height: inherit;` : `height: calc(100% - 22px);`, props => props.theme.palette.background.paper);
/**
WIDGETS :
Doc Link
*/

export const DocLinkWidgetWrapper = styled.div.withConfig({
  displayName: "widgetWrapper__DocLinkWidgetWrapper",
  componentId: "sc-1qla43x-4"
})(["display:block;"]);
export const DocLinkWidgetScroll = styled.div.withConfig({
  displayName: "widgetWrapper__DocLinkWidgetScroll",
  componentId: "sc-1qla43x-5"
})(["", " overflow:auto;position:relative;overscroll-behavior:contain;"], props => {
  const {
    getFullSizeHeight,
    widget1by1Height
  } = props.theme.props.dashboard;
  const {
    smallWidget
  } = props;
  const maxHeight = getFullSizeHeight(window.innerHeight);
  return smallWidget ? `height: ${widget1by1Height - 40}px;
         max-height: ${widget1by1Height - 40}px;` : `height: ${maxHeight}px;
         max-height: ${maxHeight}px;`;
});
/**
WIDGETS :
Frequency => max heigh is smallwidgetHeight
*/

export const FrequencyAgGridWidgetWrapper = styled.div.withConfig({
  displayName: "widgetWrapper__FrequencyAgGridWidgetWrapper",
  componentId: "sc-1qla43x-6"
})(["", " background-color:", ";width:100%;position:relative;overflow:hidden;overscroll-behavior:contain;"], props => {
  const {
    smallWidgetHeight,
    getFullSizeHeight
  } = props.theme.props.dashboard;
  const {
    smallWidget
  } = props;
  const maxHeight = getFullSizeHeight(window.innerHeight);
  return smallWidget ? `min-height: ${smallWidgetHeight}px;
         height: ${smallWidgetHeight}px;` : `height: ${maxHeight}px;
         max-height: ${maxHeight}px;`;
}, props => props.theme.palette.background.paper);
export const AppRoot = styled.div.withConfig({
  displayName: "widgetWrapper__AppRoot",
  componentId: "sc-1qla43x-7"
})(["margin-left:var(--safe-area-inset-left);margin-right:var(--safe-area-inset-right);overflow:hidden;display:flex;", " @media print{display:block;height:auto;}"], props => props.embedded ? `height: initial;` : `height: 100vh;
         height: 100dvh;`);
export const AppContent = styled.div.withConfig({
  displayName: "widgetWrapper__AppContent",
  componentId: "sc-1qla43x-8"
})(["margin-top:", "px;width:100%;", " @media print{height:auto;}"], props => props.height, props => props.embedded ? `;` : `height: calc(100vh - ${props.height}px);
         height: calc(100dvh - ${props.height}px);`);
export const Container = styled.div.withConfig({
  displayName: "widgetWrapper__Container",
  componentId: "sc-1qla43x-9"
})(["margin-left:var(--safe-area-inset-left);margin-right:var(--safe-area-inset-right);width:100%;"]);
export const BodyPrint = styled.div.withConfig({
  displayName: "widgetWrapper__BodyPrint",
  componentId: "sc-1qla43x-10"
})(["width:100%;height:100%;position:relative;color:", ";background-color:", ";@media print{page-break-after:always;color:", ";background-color:", ";}"], props => props.theme.palette.text.primary, props => props.theme.palette.background.paper, props => props.theme.palette.common.black, props => props.theme.palette.common.white);